/**
 * @generated SignedSource<<f44a955f73be1f9e82f9f733cc56fe2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoHeaderDropdownMenuQuery$data = {
  readonly videoHighlightMenu?: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly videoSectionMenu: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly videoSeriesMenu: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId?: string;
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "videoHeaderDropdownMenuQuery";
};
export type videoHeaderDropdownMenuQuery$key = {
  readonly " $data"?: videoHeaderDropdownMenuQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoHeaderDropdownMenuQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entityId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      }
    ],
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v0/*: any*/),
                "type": "Section",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v0/*: any*/),
                "type": "Topic",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v0/*: any*/),
                "type": "VideoSection",
                "abstractKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "entityLink"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:20)"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "withHighlight"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoHeaderDropdownMenuQuery",
  "selections": [
    {
      "condition": "withHighlight",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "videoHighlightMenu",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "name": "video_highlight_menu"
              }
            }
          ],
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "queue",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": "queue(filter:{\"name\":\"video_highlight_menu\"})"
        }
      ]
    },
    {
      "alias": "videoSeriesMenu",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "video_series_menu"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "queue(filter:{\"name\":\"video_series_menu\"})"
    },
    {
      "alias": "videoSectionMenu",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "video_sections_menu"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "queue(filter:{\"name\":\"video_sections_menu\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "78c0cabf209cbf946e90b860bd6f08b5";

export default node;
